import AbstractTab from "../AbstractTab";
import SpeciesRow from "../SpeciesRow";

export default class ListsTab extends AbstractTab {
    listsLoaded = false;
    listData = {};
    rows = [];
    name = 'lists';
    tooltip = 'Lists (L)';
    icon = '<svg class="icon"><use xlink:href="/icons/__remixicon.sprite.svg#list-unordered"></use></svg>';

    constructor(provider, tabContainer, isFirst = false) {
        super(provider);
        this.listInput = this.p.createDiv().parent('#p5canvas');
        this.positionListSelector();

        if (username) {
            this.createListSelector();
        } else {
            this.placeholder = this.p.createElement('p', 'Log in to see your lists')
                .parent(this.listInput)
                .class('pad');
        }

        this.listInput.hide();
        this.createButton(tabContainer, isFirst);
    }

    createListSelector() {
        this.listInput.class("planner-aside-wrapper");
        let listLabel = this.p.createElement('h3', 'Lists')
            .parent(this.listInput)
            .class('mar-t-0 mar-b');
        let inputGroup = this.p.createDiv().parent(this.listInput)
            .class("input-group");
        let selectWrapper = this.p.createDiv().parent(this.listInput)
            .class("input-select-wrapper");
        // listLabel.position(10, 10);
        this.sel = this.p.createSelect()
            .parent(selectWrapper)
            .id('list-select');
        this.sel.changed(() => this.selectList());
        this.sel.option('Choose list to import', null);
        // this.sel.position(10, 30);
        this.sel.class("input-select");
    }

    positionListSelector() {
        this.listInput.position(this.sideBar.x, 0);
    }

    resizeWindow() {
        this.positionListSelector();
    }

    activate() {
        if (username && !this.listsLoaded) {
            this.dataHandler.loadLists((data) => this.buildOptions(data));
        }
        this.button.addClass('-is-active');
        this.listInput.show();
    }

    deactivate() {
        this.button.removeClass('-is-active');
        this.spinner.reset();
        this.listInput.hide();
    }

    buildOptions(data) {
        this.listsLoaded = true;
        for (let [key, value] of Object.entries(data)) {
            if (value.plants.length == 0) {
                continue;
            }
            this.sel.option(value.name, key);
            let rowContainer = this.p.createDiv()
                .parent(this.listInput)
                .class('pad-b')
                .id('listcontainer-' + key)
            this.listData[key] = value.plants.map(plant => new SpeciesRow(this.provider, plant, rowContainer).without(['remove']));
            rowContainer.hide();
        }
    }

    loadLists() {
        let uri = `/${username}/plans/lists`;
        spinner = new Spinner(this.sideBar.x + this.sideBar.width / 2, 150, 80);
        httpDo(
            uri,
            {
                method: 'GET',
                headers: {
                    'X-CSRF-Token': token,
                    'Accept': 'application/json',
                }
            },
            (data) => {
                this.listsLoaded = true;
                data = JSON.parse(data);
                for (let [key, value] of Object.entries(data)) {
                    if (value.plants.length == 0) {
                        continue;
                    }
                    this.sel.option(value.name, key);
                    let rowContainer = createDiv()
                        .parent(this.listInput)
                        .class('pad-b')
                        .id('listcontainer-' + key)
                    // .position(0, 70)
                    // .style('overflow-y', 'scroll');
                    this.listData[key] = value.plants.map((plant, index) => new SpeciesRow(plant, index, rowContainer)).without(['remove']);
                    rowContainer.hide();
                }
                spinner = null;
            }
        );
    }

    selectList() {
        this.p.selectAll('.listcontainer').map((container) => container.hide());
        this.p.select('#listcontainer-' + this.sel.value()).show();
    }
}
